import { useState } from 'react';
import ReactPlayer from 'react-player';

function VideoPlayer({ url }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        className="text-2xl text-black-700 hover:text-[#b70303] focus:outline-none"
        onClick={() => setShowModal(true)}
      >
        <span className='underline'>How-to Video</span>
     
      </button>
     
      {showModal && (
        <div className="fixed mt-2 z-40 inset-0 overflow-hidden">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75"></div>
            <div className="relative z-10 max-w-screen-lg w-full bg-white py-14 rounded-lg">
              <div className="flex justify-center items-center">
                <h1 className="font-black text-4xl text-[#b70303]">
                  <strong>How-to Video</strong>
                </h1>
              </div>

              <button
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 focus:outline-none"
                onClick={() => setShowModal(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>

              <div className="aspect-w-21 aspect-h-9 md:aspect-w-16 md:aspect-h-10 ">
                <ReactPlayer url={url} controls width="100%" height="50vh"   />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default VideoPlayer;
